import { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { cn } from '@/lib/utils'

interface RoomQrProps {
  url: string
  className?: string
  size?: number
}

/** Renders a QR code for the room share URL (scan → open link → auto-join). */
export function RoomQr({ url, className, size = 180 }: RoomQrProps) {
  const [dataUrl, setDataUrl] = useState<string>('')
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    if (!url) {
      setDataUrl('')
      return
    }
    setError(false)
    void QRCode.toDataURL(url, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#18181b', light: '#ffffff' },
    })
      .then((d) => {
        if (!cancelled) setDataUrl(d)
      })
      .catch(() => {
        if (!cancelled) {
          setDataUrl('')
          setError(true)
        }
      })
    return () => {
      cancelled = true
    }
  }, [url, size])

  if (!url) return null

  if (error) {
    return (
      <p className="text-muted-foreground text-center text-xs">二维码生成失败，请使用复制链接</p>
    )
  }

  if (!dataUrl) {
    return (
      <div
        className={cn('bg-muted/40 mx-auto animate-pulse rounded-lg', className)}
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <img
      src={dataUrl}
      alt="房间二维码"
      width={size}
      height={size}
      className={cn('mx-auto rounded-lg border bg-white p-2', className)}
    />
  )
}
